import { useCallback, useState } from 'react';

import { getCookie, setCookie } from 'utils/cookies';

export default function useCookie(name: string) {
    const [value, setValueInternal] = useState<string | undefined>(() => getCookie(name));

    const setValue = useCallback(
        (value: string) => {
            setValueInternal(value);
            setCookie(name, value, { ['max-age']: Number.MAX_SAFE_INTEGER });
        },
        [name]
    );

    return [value, setValue] as const;
}
